// @ts-check
export function wrapString(stringToWrap, newBlock, attributes = {}) {
    let wrapper = document.createElement(newBlock);
    wrapper.innerText = stringToWrap;

    for (const [attr, val] of Object.entries(attributes)) {
        wrapper.setAttribute(attr, val);
    }

    return wrapper.outerHTML;
}

export function wrapElement(elementToWrap, newBlock = 'div', attributes = {}) {
    let wrapper = document.createElement(newBlock);

    for (const [attr, val] of Object.entries(attributes)) {
        wrapper.setAttribute(attr, val);
    }

    elementToWrap.parentNode.insertBefore(wrapper, elementToWrap);
    wrapper.appendChild(elementToWrap);
}

/**
 * Wrap all nodes in the given HTML.
 *
 * @param {NodeListOf<Node>} nodes The nodes to wrap.
 * @param {string} html The HTML to wrap the nodes in.
 * @param {Node | null} parent The parent node to append the wrapped nodes to (optional).
 */
export function wrapAll(nodes, html, parent = null) {
    if (parent === null) {
        parent = nodes[0].parentNode;
    }

    const template = document.createElement('template');
    template.innerHTML = html;

    deepestElement(template.content).append(...nodes);
    parent?.appendChild(template.content);
}

/**
 * Returns the deepest element.
 *
 * @param {DocumentFragment | Element} current
 */
export function deepestElement(current) {
    const child = current.firstElementChild;

    if (!child) {
        return current;
    }

    return deepestElement(child);
}
